module.exports = __webpack_public_path__ + "static/metal06-8f0b038133a2860dcf1fc5ab8526da6e.png";